import * as THREE from 'three'
import { OrbitControls } from './addons/controls/OrbitControls.js'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'
import 'lenis/dist/lenis.css'

class ScrollAnimation {
  constructor(el) {
    this.dom = {el: el}
    this.canvasH = this.dom.el.clientHeight;

    this.winDefaultW = 1280;
    this.winDefaultHarfW = this.winDefaultW * .5;
    this.winDefaultH = 640;

    // ＋のサイズ（+を敷き詰めるシーン）
    this.plusSize = {
      w: 114,
      h: 114,
    }
    // plus.pngのサイズ（正方形）
    this.plusImageSize = 576;
    // ＋の下に伸びている部分の幅
    this.plusUnderBarW = this.plusSize.w * (138 / this.plusImageSize);
    // ＋の下に伸びている部分の幅 + 左側の伸びている部分の幅
    this.plusLeftBarW = this.plusSize.w * (356 / this.plusImageSize);
    // ＋の横の伸びている部分の高さ
    this.plusSideBarH = this.plusSize.h * (140 / this.plusImageSize);
    // ＋の下に伸びている部分の高さ + 横に伸びている部分の高さ
    this.plusSideBarH = this.plusSize.h * (358 / this.plusImageSize);
    this.plusCol = 28; // 列の設定
    this.plusRow = 28; // 行の設定

    // 画像の比率(h / w)
    this.aspect = {
      t01: 135 / 555,
      t02: 47 / 322,
      t03: 47 / 322,
      t04: 84 / 918,
      t05: 32 / 512,
    }

    // サイズ
    this.sizes = {
      width: innerWidth,
      height: innerHeight
    }

    this.renderer = null;
    this.scene = null;
    this.camera = null;
    this.distance = null;

    window.addEventListener('load', () => {
      setTimeout(()=>{
        window.scroll({top: 0, behavior: 'instant'});
      }, 100)
      this.init();
    })
  }

  init() {
    let pointLight;

    // canvas
    const canvas = document.querySelector('#webgl');

    // シーン
    this.scene = new THREE.Scene();

    // フォグを設定
    // new THREE.Fog(色, 開始距離, 終点距離);
    // scene.fog = new THREE.Fog(0xffffff, 50, 2000);

    // const size = 10;
    // this.scene.add(new THREE.AxesHelper(size));

    // const divisions = 5;
    // this.scene.add(new THREE.GridHelper(size, divisions));

    // 背景用のテクスチャ
    const bgLoader = new THREE.TextureLoader();
    // const bgTexture = bgLoader.load('../assets/img/fv/bg.jpg');
    // this.scene.background = bgTexture;
    this.scene.background = new THREE.Color('#fff')

    // 視野角をラジアンに変換
    const fov = 50;
    const fovRad = (fov / 2) * (Math.PI / 180);
    // カメラ距離を求める
    this.distance = (window.innerHeight / 2) / Math.tan(fovRad);

    // カメラ
    this.camera = new THREE.PerspectiveCamera(
      fov, // 視野角
      this.sizes.width / this.sizes.height, // アスペクト比（画面の比率）
      10, // カメラで表示させる範囲（near）
      3000 // カメラで表示させる範囲（far）
    );
    this.camera.position.set(0, 0, this.distance);

    // レンダラー
    this.renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      antialias: true,
      alpha: true
    });
    this.renderer.setSize(this.sizes.width, this.sizes.height);
    this.renderer.setPixelRatio(window.devicePixelRatio); // 画面の粗さが軽減される

    // マウス操作
    // const controls = new OrbitControls(camera, this.renderer.domElement);
    // controls.enableDamping = true;

    this.playAnimation();
  }

  playAnimation() {

    // テクスチャ設定
    const plusTextureLoader = new THREE.TextureLoader();
    const plusTexture = plusTextureLoader.load('../assets/img/fv/plus.png');

    // スクロールアニメーション
    const animationScripts = [];



    /**
    * ベースの設定 ---------------------------------------------------
    */
    // ノイズのテクスチャーを全面に被せる
    const noiseTextureLoader = new THREE.TextureLoader();
    const noiseTexture = noiseTextureLoader.load('../assets/img/fv/noise.png');
    noiseTexture.wrapS = THREE.RepeatWrapping;
    noiseTexture.wrapT = THREE.RepeatWrapping;
    noiseTexture.repeat.set( this.sizes.width / 150, this.sizes.height / 150 );
    const noiseGeomery = new THREE.PlaneGeometry(this.sizes.width, this.sizes.height);
    const noiseMaterial = new THREE.MeshBasicMaterial({
      map: noiseTexture,
      transparent: true,
      opacity: .5,
    });
    let noiseMesh = new THREE.Mesh(noiseGeomery, noiseMaterial);
    noiseMesh.position.set(0, 0, 10);
    this.scene.add(noiseMesh);



    /**
    * オープニングの処理 ---------------------------------------------------
    */
    const opening = document.querySelector('[data-js="opening"]');
    // オープニングのフェードアウト
    animationScripts.push({
      start: 4,
      end: 8,
      anim: () => {
        opening.style.opacity = lerp(1, 0, scalePercent(4, 8))
      },
      setStart: () => {
        opening.style.opacity = 1;
      },
      setEnd: () => {
        opening.style.opacity = 0;
      }
    })



    /**
    * ＋が敷き詰められるシーンの作成 ---------------------------------------------------
    */
    // ＋を生成
    const group = new THREE.Group(); // グループ化用

    let centeredX = 0, centeredY = 0;
    for (let y = 0; y < this.plusRow; y++) {
      for (let x = 0; x < this.plusCol; x++) {
        let z = Math.random() * 500 + this.distance; // z軸の位置をランダムに設定
        // オブジェクトを作成
        const tileGeometry = new THREE.PlaneGeometry(this.plusSize.w, this.plusSize.h);
        const tileMaterial = new THREE.MeshBasicMaterial({
          map: plusTexture,
          side: THREE.DoubleSide,
          transparent: true,
          alphaTest: 1,
          color: '#fff',
          opacity: 1,
        });
        const tileMesh = new THREE.Mesh(tileGeometry, tileMaterial);
        if (y % 2 === 1) { // odd
          tileMesh.position.set(
            // x * (this.plusSize.w + this.plusUnderBarW) + this.plusUnderBarW + (this.plusSize.w * (358 / 576)),
            x * (this.plusSize.w + this.plusUnderBarW) + this.plusLeftBarW,
            y * this.plusSideBarH,
            z
          );
        } else { // even
          tileMesh.position.set(
            // x * (this.plusSize.w + this.plusUnderBarW) + this.plusUnderBarW,
            x * (this.plusSize.w + this.plusUnderBarW),
            y * this.plusSideBarH,
            z
          );
        }
        group.add(tileMesh); // 生成した＋のオブジェクトをグループ化

        // 最初は非表示にしておく
        gsap.set(tileMesh.material, {
          opacity: 1
        })

        // ＋をタイル状にはめていく
        animationScripts.push({
          start: 10,
          end: 20,
          anim: () => {
            tileMesh.position.z = lerp(z, -500, scalePercent(10, 20))
          },
          setStart: () => {
            tileMesh.position.z = z;
          },
          setEnd: () => {
            tileMesh.position.z = -500;
          }
        })

        // タイル状の＋を奥に移動させて小さく見せる
        animationScripts.push({
          start: 30,
          end: 42,
          anim: () => {
            tileMesh.position.z = lerp(-500, -1000, scalePercent(30, 42))
          },
          setStart: () => {
          },
          setEnd: () => {
            tileMesh.position.z = -1000;
          }
        })
      }
    }

    // グループ化してまとめたものを画面中央に配置
    let centerX = ((this.plusSize.w + this.plusUnderBarW) * this.plusCol) * .5;
    let centerY = (this.plusSideBarH * this.plusRow) * .5;
    group.position.set(-centerX, -centerY, 0);
    // console.log({group})

    // シーンに追加
    this.scene.add(group);

    // フェードアウトしているように見せるためのジオメトリを作成
    const cover01Geomery = new THREE.PlaneGeometry(this.sizes.width, this.sizes.height);
    const cover01Material = new THREE.MeshBasicMaterial({
      transparent: true,
      color: 0xffffff,
    });
    let cover01Mesh = new THREE.Mesh(cover01Geomery, cover01Material);
    // cover01Mesh.position.set(-(this.sizes.width * .5 - (this.sizes.width * .5)), -(this.sizes.height * .5 - (this.sizes.height * .5)), 2);
    cover01Mesh.position.set(0, 0, 2);

    // 最初は非表示にしておく
    gsap.set(cover01Mesh.material, {
      opacity: 0
    })

    // cover01を表示にしていく
    animationScripts.push({
      start: 38,
      end: 40,
      anim: () => {
        cover01Mesh.material.opacity = lerp(0, 1, scalePercent(38, 40))
      },
      setStart: () => {
        cover01Mesh.material.opacity = 0;
      },
      setEnd: () => {
        cover01Mesh.material.opacity = 1;
      }
    })

    // シーンに追加
    this.scene.add(cover01Mesh);



    /**
    * 敷き詰められた＋が円でマスクされるシーンの作成 ---------------------------------------------------
    */
    // text01（1989, Began supporting the recruitment of Japanese-English bilingual talent.）の生成
    let t01W = this.getRelativeSize(555, this.winDefaultW);
    let t01H = t01W * this.aspect.t01;
    let t01PosX01 = this.getRelativeSize(267, this.winDefaultW);
    let t01PosY01 = this.getRelativeSize(0, this.winDefaultW);
    const t01TextureLoader = new THREE.TextureLoader();
    const t01Texture = t01TextureLoader.load('../assets/img/fv/text-01-en@pc.png');
    const t01Geomery = new THREE.PlaneGeometry(t01W, t01H);
    const t01Material = new THREE.MeshBasicMaterial({
      map: t01Texture,
      transparent: true,
    });
    let t01Mesh = new THREE.Mesh(t01Geomery, t01Material);
    t01Mesh.position.set(-t01PosX01, -t01PosY01, 11);

    // 最初は非表示にしておく
    gsap.set(t01Mesh.material, {
      opacity: 0
    })

    // 文字のフェードイン
    animationScripts.push({
      start: 20,
      end: 22,
      anim: () => {
        t01Mesh.material.opacity = lerp(0, 1, scalePercent(20, 22))
      },
      setStart: () => {
        t01Mesh.material.opacity = 0;
      },
      setEnd: () => {}
    })

    // 文字のフェードアウト
    animationScripts.push({
      start: 40,
      end: 44,
      anim: () => {
        t01Mesh.material.opacity = lerp(1, 0, scalePercent(40, 44))
      },
      setStart: () => {},
      setEnd: () => {
        t01Mesh.material.opacity = 0;
      }
    })

    // シーンに追加
    this.scene.add(t01Mesh);

    // 生成した＋をマスクする感じにリングジオメトリを全面に表示させる
    // 参考（http://thirdjs.blog.fc2.com/blog-entry-8.html）
    // リング状のジオメトリを生成
    const outerRad = this.sizes.width * 1.25;
    const innerRad = this.sizes.height * .0165;
    const pseudoClippingGeometry = new THREE.RingGeometry(innerRad, outerRad, 30, 1);
    const pseudoClippingMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      // transparent: true,
      // alphaTest: 0,
    });
    let pseudoClippingMesh = new THREE.Mesh(pseudoClippingGeometry, pseudoClippingMaterial);
    pseudoClippingMesh.position.set(0, 0, 0);
    pseudoClippingMesh.scale.set(100, 100, 0);

    // ジオメトリを縮小してマスクしているように見せる
    animationScripts.push({
      start: 30,
      end: 42,
      anim: () => {
        pseudoClippingMesh.scale.x = lerp(100, 5, scalePercent(30, 42))
        pseudoClippingMesh.scale.y = lerp(100, 5, scalePercent(30, 42))
      },
      setStart: () => {
        pseudoClippingMesh.scale.x = 100
        pseudoClippingMesh.scale.y = 100
      },
      setEnd: () => {
        pseudoClippingMesh.scale.x = 5
        pseudoClippingMesh.scale.y = 5
        pseudoClippingMesh.scale.z = 5
      }
    })

    animationScripts.push({
      start: 44,
      end: 44.5,
      anim: () => {
      },
      setStart: () => {
        pseudoClippingMesh.material.opacity = 1;
      },
      setEnd: () => {
        pseudoClippingMesh.material.opacity = 0;
      }
    })

    // シーンに追加
    this.scene.add(pseudoClippingMesh);



    /**
    * 左右から円が移動してくるシーンの作成 ---------------------------------------------------
    */
    // 文字の生成
    // テクスチャ設定
    // text02（I want to succeed globally by leveraging on my experience abroad.）の生成
    let t02W = this.getRelativeSize(322, this.winDefaultW);
    let t02H = t02W * this.aspect.t02;
    let t02posX = this.sizes.width * ((this.winDefaultHarfW - 406) / this.winDefaultW);
    let t02posY = (176 / this.winDefaultH) * this.sizes.height - (58 * .5);
    const t02TextureLoader = new THREE.TextureLoader();
    const t02Texture = t02TextureLoader.load('../assets/img/fv/text-02-en@pc.png');
    const t02Geomery = new THREE.PlaneGeometry(t02W, t02H);
    const t02Material = new THREE.MeshBasicMaterial({
      map: t02Texture,
      transparent: true,
    });
    let t02Mesh = new THREE.Mesh(t02Geomery, t02Material);
    t02Mesh.position.set(-t02posX, -t02posY, 13);

    // text03（I want to grow my business by hiring global talent.）の生成
    let t03W = this.getRelativeSize(322, this.winDefaultW);
    let t03H = t03W * this.aspect.t03;
    let t03posX = this.sizes.width * ((this.winDefaultHarfW - 406) / this.winDefaultW);
    let t03posY = (176 / this.winDefaultH) * this.sizes.height - (58 * .5);
    const t03TextureLoader = new THREE.TextureLoader();
    const t03Texture = t03TextureLoader.load('../assets/img/fv/text-03-en@pc.png');
    const t03Geomery = new THREE.PlaneGeometry(t03W, t03H);
    const t03Material = new THREE.MeshBasicMaterial({
      map: t03Texture,
      transparent: true,
    });
    let t03Mesh = new THREE.Mesh(t03Geomery, t03Material);
    t03Mesh.position.set(t03posX, -t03posY, 13);

    // copyを最初は非表示にしておく
    gsap.set(t02Mesh.material, { opacity: 0 })
    gsap.set(t03Mesh.material, { opacity: 0 })

    // 文字のフェードイン
    animationScripts.push({
      start: 46,
      end: 48,
      anim: () => {
        t02Mesh.material.opacity = lerp(0, 1, scalePercent(46, 48))
        t03Mesh.material.opacity = lerp(0, 1, scalePercent(46, 48))
      },
      setStart: () => {
        t02Mesh.material.opacity = 0;
        t03Mesh.material.opacity = 0;
      },
      setEnd: () => {}
    })

    // 文字のフェードアウト
    animationScripts.push({
      start: 60,
      end: 62,
      anim: () => {
        t02Mesh.material.opacity = lerp(1, 0, scalePercent(60, 62))
        t03Mesh.material.opacity = lerp(1, 0, scalePercent(60, 62))
      },
      setStart: () => {},
      setEnd: () => {
        t02Mesh.material.opacity = 0;
        t03Mesh.material.opacity = 0;
      }
    })

    // シーンに追加
    this.scene.add(t02Mesh, t03Mesh);

    // 円のジオメトリを生成
    const r = 22;
    let startPosX = this.sizes.width * .5 + r;
    let endPosX = this.sizes.width * ((this.winDefaultHarfW - 406) / this.winDefaultW);
    const circleGeometryL = new THREE.CircleGeometry(r, 32);
    const circleGeometryR = new THREE.CircleGeometry(r, 32);
    const circleMaterial = new THREE.MeshBasicMaterial({
      // map: circleTexture,
      transparent: true,
      color: 0xB6E0E0,
    });
    let circleMeshL = new THREE.Mesh(circleGeometryL, circleMaterial);
    let circleMeshR = new THREE.Mesh(circleGeometryR, circleMaterial);
    circleMeshL.position.set(-startPosX, 0, 11);
    circleMeshR.position.set(startPosX, 0, 11);

    // 左右から円を中央付近に配置
    animationScripts.push({
      start: 50,
      end: 56,
      anim: () => {
        circleMeshL.position.x = lerp(-startPosX, -endPosX, scalePercent(50, 56))
        circleMeshR.position.x = lerp(startPosX, endPosX, scalePercent(50, 56))
      },
      setStart: () => {
        circleMeshL.position.x = -startPosX;
        circleMeshR.position.x = startPosX;
      },
      setEnd: () => {}
    })

    const circleZoom = 160 / 22;
    // 円を拡大
    animationScripts.push({
      start: 52,
      end: 60,
      anim: () => {
        circleMeshL.scale.x = lerp(1, circleZoom, scalePercent(52, 60));
        circleMeshL.scale.y = lerp(1, circleZoom, scalePercent(52, 60));
        circleMeshR.scale.x = lerp(1, circleZoom, scalePercent(52, 60));
        circleMeshR.scale.y = lerp(1, circleZoom, scalePercent(52, 60));
      },
      setStart: () => {
        circleMeshL.scale.x = 1;
        circleMeshL.scale.y = 1;
        circleMeshR.scale.x = 1;
        circleMeshR.scale.y = 1;
      },
      setEnd: () => {
        circleMeshL.scale.x = circleZoom;
        circleMeshL.scale.y = circleZoom;
        circleMeshR.scale.x = circleZoom;
        circleMeshR.scale.y = circleZoom;
      }
    })

    // 透明度を下げて非表示に
    animationScripts.push({
      start: 84,
      end: 92,
      anim: () => {
        circleMeshL.material.opacity = lerp(1, 0, scalePercent(84, 92))
        circleMeshR.material.opacity = lerp(1, 0, scalePercent(84, 92))
      },
      setStart: () => {
        circleMeshL.material.opacity = 1;
        circleMeshR.material.opacity = 1;
      },
      setEnd: () => {
        circleMeshL.material.opacity = 0;
        circleMeshR.material.opacity = 0;
      }
    })

    // シーンに追加
    this.scene.add(circleMeshL, circleMeshR);



    /**
    * 円が大きくなって全体を埋め尽くすシーンの作成 ---------------------------------------------------
    */
    // text04（We have continued to elevate all individuals and companies whose ambitions go beyond borders.）の生成
    let t04W = this.getRelativeSize(918, this.winDefaultW);
    let t04H = t04W * this.aspect.t04;
    const t04TextureLoader = new THREE.TextureLoader();
    const t04Texture = t04TextureLoader.load('../assets/img/fv/text-04-en@pc.png');
    const t04Geomery = new THREE.PlaneGeometry(t04W, t04H);
    const t04Material = new THREE.MeshBasicMaterial({
      map: t04Texture,
      transparent: true,
    });
    let t04Mesh = new THREE.Mesh(t04Geomery, t04Material);
    t04Mesh.position.set(0, 0, 12);

    // copyを最初は非表示にしておく
    gsap.set(t04Mesh.material, {
      opacity: 0
    })

    // 文字のフェードイン
    animationScripts.push({
      start: 66,
      end: 68,
      anim: () => {
        t04Mesh.material.opacity = lerp(0, 1, scalePercent(66, 68))
      },
      setStart: () => {
        t04Mesh.material.opacity = 0;
      },
      setEnd: () => {}
    })

    // 文字のフェードアウト
    animationScripts.push({
      start: 80,
      end: 84,
      anim: () => {
        t04Mesh.material.opacity = lerp(1, 0, scalePercent(80, 84))
      },
      setStart: () => {},
      setEnd: () => {
        t04Mesh.material.opacity = 0;
      }
    })

    // シーンに追加
    this.scene.add(t04Mesh);

    // 円のジオメトリを生成
    let cols = 4;
    let rows = 3;
    const circleGroup = new THREE.Group();
    const length = rows * cols;
    const radius = 30;
    const diameter = radius * 2;
    const finishScale = 50;
    let rowsIndex = 1;
    let colsIndex = 1;
    for (let i = 1; i <= length; i++) {
      const radiusSize = radius;

      colsIndex = i - ((rowsIndex - 1) * cols);

      const posX = (this.sizes.width / (cols + 1)) * (colsIndex - 1);
      const posY = (this.sizes.height / (rows + 1)) * (rowsIndex - 1);

      rowsIndex = (i % cols === 0) ? rowsIndex + 1 : rowsIndex;

      const circleZoomGeometry = new THREE.CircleGeometry(radiusSize, 32);
      const circleZoomMaterial = new THREE.MeshBasicMaterial({
        // map: circleTexture,
        transparent: true,
        alphaTest: 0,
        opacity: 1,
        color: 0xB6E0E0,
      });

      let circleZoomMesh = new THREE.Mesh(circleZoomGeometry, circleZoomMaterial);

      const slipX = ((Math.random() * diameter * 2) - diameter) * 2;
      const slipY = ((Math.random() * diameter * 2) - diameter) * 2;
      circleZoomMesh.position.set(posX + slipX, posY + slipY, 11);

      gsap.set(circleZoomMesh.material, {
        opacity: 0
      })

      // 複数の円を拡大させて画面を埋め尽くす
      animationScripts.push({
        start: 56,
        end: 80,
        anim: () => {
          circleZoomMesh.material.opacity = lerp(0, 1, scalePercent(56, 56.5))
          circleZoomMesh.scale.x = lerp(1, finishScale, scalePercent(56, 80))
          circleZoomMesh.scale.y = lerp(1, finishScale, scalePercent(56, 80))
        },
        setStart: () => {
          circleZoomMesh.material.opacity = 0
          circleZoomMesh.scale.x = 1
          circleZoomMesh.scale.y = 1
        },
        setEnd: () => {}
      })

      // 透明度を下げて非表示に
      animationScripts.push({
        start: 84,
        end: 92,
        anim: () => {
          circleZoomMesh.material.opacity = lerp(1, 0, scalePercent(84, 92))
        },
        setStart: () => {
        },
        setEnd: () => {
          circleZoomMesh.material.opacity = 0
          circleZoomMesh.scale.x = finishScale
          circleZoomMesh.scale.y = finishScale
        }
      })

      circleGroup.add(circleZoomMesh);
    }

    const circleGposX = (this.sizes.width * .5) - (this.sizes.width / (cols + 1));
    const circleGposY = (this.sizes.height * .5) - (this.sizes.height / (rows + 1));
    circleGroup.position.set(-circleGposX, -circleGposY, 0);

    // シーンに追加
    this.scene.add(circleGroup);



    /**
    * ＋が下から湧き出してくるシーンの作成 ---------------------------------------------------
    */
    const goGroup = new THREE.Group();
    const number = 24;
    let goW = 114, goH = 114;
    for (let i = 0; i < number; i++) {
      let z = (Math.random() * this.distance) * .1;
      // オブジェクトを作成
      const gushGeometry = new THREE.PlaneGeometry(goW, goH);
      const gushMaterial = new THREE.MeshBasicMaterial({
        map: plusTexture,
        side: THREE.DoubleSide,
        transparent: true,
        alphaTest: 0,
        color: '#fff',
        opacity: .2,
        blending: THREE.AdditiveBlending
      });
      const gush = new THREE.Mesh(gushGeometry, gushMaterial);
      const scale = (Math.random() * 2.5) + .5;
      gush.scale.set(scale, scale, Math.random() * z);

      const posX = goW * i;
      const posY = (this.sizes.height + (goH * scale)) + (i * goH * Math.random());
      const posZ = Math.random() * 200;
      gush.position.set(posX, -posY, posZ);

      const finishPosY = posY + (Math.random() * scale + this.sizes.height);

      // +マークが下から上へ湧き出す
      animationScripts.push({
        start: 74,
        end: 86,
        anim: () => {
          gush.position.y = lerp(-posY, finishPosY, scalePercent(74, 86))
        },
        setStart: () => {
          gush.position.y = -posY;
        },
        setEnd: () => {
          gush.position.y = posY;
        }
      })

      goGroup.add(gush);
    }

    goGroup.position.x = -(goW * number) * .5;

    // シーンに追加
    this.scene.add(goGroup);



    /**
    * ＋がループするシーンの作成 ---------------------------------------------------
    */
    // text05（This sentiment will never change.）の生成
    let t05W = this.getRelativeSize(512, this.winDefaultW);
    let t05H = t05W * this.aspect.t05;
    const t05TextureLoader = new THREE.TextureLoader();
    const t05Texture = t05TextureLoader.load('../assets/img/fv/text-05-en@pc.png');
    const t05Geomery = new THREE.PlaneGeometry(t05W, t05H);
    const t05Material = new THREE.MeshBasicMaterial({
      map: t05Texture,
      transparent: true,
    });
    let t05Mesh = new THREE.Mesh(t05Geomery, t05Material);
    t05Mesh.position.set(0, 0, 13);

    // copyを最初は非表示にしておく
    gsap.set(t05Mesh.material, {
      opacity: 0
    })

    // 文字のフェードイン
    animationScripts.push({
      start: 88,
      end: 92,
      anim: () => {
        t05Mesh.material.opacity = lerp(0, 1, scalePercent(88, 92))
      },
      setStart: () => {
        t05Mesh.material.opacity = 0;
      },
      setEnd: () => {}
    })

    // シーンに追加
    this.scene.add(t05Mesh);

    // フェードアウトしているように見せるためのジオメトリを作成
    const cover02Geomery = new THREE.PlaneGeometry(this.sizes.width, this.sizes.height);
    const cover02Material = new THREE.MeshBasicMaterial({
      transparent: true,
      color: 0xffffff,
    });
    let cover02Mesh = new THREE.Mesh(cover02Geomery, cover02Material);
    cover02Mesh.position.set(-(this.sizes.width * .5 - (this.sizes.width * .5)), -(this.sizes.height * .5 - (this.sizes.height * .5)), 12);

    // 最初は非表示にしておく
    gsap.set(cover02Mesh.material, {
      opacity: 0
    })

    // cover02を表示にしていく
    animationScripts.push({
      start: 88,
      end: 92,
      anim: () => {
        cover02Mesh.material.opacity = lerp(0, 1, scalePercent(88, 92))
      },
      setStart: () => {
        cover02Mesh.material.opacity = 0;
      },
      setEnd: () => {}
    })

    // cover02を非表示にしていく
    animationScripts.push({
      start: 93,
      end: 97,
      anim: () => {
        cover02Mesh.material.opacity = lerp(1, 0, scalePercent(93, 97))
      },
      setStart: () => {},
      setEnd: () => {
        cover02Mesh.material.opacity = 0;
      }
    })

    // シーンに追加
    this.scene.add(cover02Mesh);

    // ループ用の＋を生成
    const len = 30, gap = 20;
    let loopW = 50, loopH = 50;
    let loopArray = [];
    for (let i = 0; i < len; i++) {
      // オブジェクトを作成
      const loopTileGeometry = new THREE.PlaneGeometry(loopW, loopH);
      const loopTileMaterial = new THREE.MeshBasicMaterial({
        map: plusTexture,
        side: THREE.DoubleSide,
        transparent: true,
        alphaTest: 1,
        color: '#fff',
        opacity: 1,
      });
      const loopTile = new THREE.Mesh(loopTileGeometry, loopTileMaterial);
      loopTile.position.set((i * (loopW + gap)) - (this.sizes.width * .5), -78, 11);
      loopArray.push(loopTile);

      // copyを最初は非表示にしておく
      gsap.set(loopTile.material, {
        opacity: 0
      })

      // ループしている＋を表示
      animationScripts.push({
        start: 92,
        end: 93,
        anim: () => {
          return;
        },
        setStart: () => {
          loopTile.material.opacity = 0;
        },
        setEnd: () => {
          loopTile.material.opacity = 1;
        }
      })

      // シーンに追加
      this.scene.add(loopTile);
    }

    // 線形補間で滑らかに移動させる
    function lerp(x, y, a) {
      return (1 - a) * x + a * y;
    }

    function scalePercent(start, end) {
      return (scrollParcent - start) / (end - start);
    }

    // アニメーションを開始
    function playScrollAnimation() {
      animationScripts.forEach((animation) => {
        if (scrollParcent < animation.start) {
          animation.setStart();
        } else if (scrollParcent >= animation.start && scrollParcent <= animation.end) {
          animation.anim();
        } else if (scrollParcent > animation.end) {
          animation.setEnd();
        }
      })
    }

    // ブラウザのスクロール率を取得
    let scrollParcent = 0;
    document.body.onscroll = () => {
      // scrollParcent = (document.documentElement.scrollTop / (document.documentElement.scrollHeight - document.documentElement.clientHeight)) * 100;
      scrollParcent = (document.documentElement.scrollTop / (this.canvasH - document.documentElement.clientHeight)) * 100;
      // console.log({ scrollParcent })
      playScrollAnimation();
    }

    // アニメーション
    const tick = () => {
      window.requestAnimationFrame(tick);
      this.renderer.render(this.scene, this.camera);
      // playScrollAnimation(); // スクロールに合わせてアニメーションさせるのでこれはコメントアウト

      [...loopArray].forEach((el) => {
        el.position.x -= .5;
        if (el.position.x <= -((this.sizes.width * .5) + loopW + gap)) {
          el.position.x = (loopW + gap) * (len - 1) - (this.sizes.width * .5);
        }
      })
    }
    // this.renderer.setAnimationLoop( tick );
    tick();

    // ブラウザのリサイズ操作
    window.addEventListener('resize', () => {
      this.sizes.width = window.innerWidth;
      this.sizes.height = window.innerHeight;

      this.camera.aspect = this.sizes.width / this.sizes.height; // カメラのアスペクト比も変わるので変更が必要
      this.camera.updateProjectionMatrix(); // これを書かないとカメラのアスペクト比が変更しない

      // circleMeshL、circleMeshRの位置を更新
      startPosX = this.sizes.width * .5 + r;
      endPosX = this.sizes.width * ((this.winDefaultHarfW - 406) / this.winDefaultW);

      this.renderer.setSize(this.sizes.width, this.sizes.height);
      this.renderer.setPixelRatio(window.devicePixelRatio);
    })

    const lenis = new Lenis({
      lerp: .08,
      prevent: (node) => node.id === 'textver-message',
    })
    lenis.on('scroll', (e) => {
      // console.log(e)
    })
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add((time)=>{
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)
  }

  getRelativeSize(size, parent) {
    const sizes = {
      width: innerWidth,
      height: innerHeight
    }
    return (size / parent) * this.sizes.width;
  }
}

export default ScrollAnimation
